import React from "react";
import Navbar from "../componenst/Navbar";
import Compmain from "../componenst/Profilpemain/Compmain";
export default function Profilpemain() {
  return (
    <div>
      <Navbar judul="Detail pemain" aicon="true" />
      <Compmain />
    </div>
  );
}
